export default "__VITE_ASSET__4b4d9f91__"